<button
  class="relative w-[32px] h-[32px] lg:w-auto lg:h-auto flex items-center justify-center text-txt cursor-pointer"
  (click)="announcementsMenuTrigger.openMenu()" aria-label="Announcements">
  <svg-icon key="bell" class="text-[20px]!"></svg-icon>
  @if (unreadCount$ | async; as unreadCount) {
  <span
    class="absolute top-0 right-0 lg:-top-xs lg:-right-sm min-w-lg h-lg px-2xs rounded-full bg-error text-contrast text-2xs leading-2xs text-center font-semibold">
    {{ unreadCount > 99 ? '99+' : unreadCount }}
  </span>
  }
</button>
<!-- Hidden anchor: on mobile it sits at the header's bottom-left so the panel
       opens full-width below the header; on lg+ it stays inline next to the bell -->
<div class="absolute bottom-0 left-sm lg:static" [matMenuTriggerFor]="announcementsMenu"
  #announcementsMenuTrigger="matMenuTrigger" (menuOpened)="menuOpened()"></div>
<mat-menu #announcementsMenu="matMenu" [hasBackdrop]="true" class="announcements-mat-menu">
  <ng-template matMenuContent>
    <div class="announcements-panel p-base border border-ui-separator rounded-sm" (click)="$event.stopPropagation()">
      <div class="flex items-center justify-between gap-lg">
        <div class="text-base leading-base text-txt font-semibold">Announcements</div>
        <button class="flex items-center gap-sm text-sm leading-sm text-primary" (click)="viewAll()"
          aria-label="View all announcements">
          View all
          <svg-icon key="arrow-right" class="text-sm!"></svg-icon>
        </button>
      </div>

      @if (visibleAnnouncements$ | async; as announcements) {
      @if (announcements.length === 0) {
      <div class="py-lg text-sm leading-sm text-txt-secondary text-center">
        No new announcements
      </div>
      }

      <div class="mt-xl max-h-[420px] overflow-y-auto">
        @for (item of announcements; track item.recipientId) {
        <lla-announcement-list-item [item]="item" (opened)="openItem(item)"></lla-announcement-list-item>
        }
      </div>
      } @else {
      <div class="flex items-center justify-center py-lg">
        <lla-loading-spinner></lla-loading-spinner>
      </div>
      }
    </div>
  </ng-template>
</mat-menu>